import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { t } from '../../../../locales';
import { isApp } from '../../../../utils';
import { setNavigationBarTitle } from '../../../../utils/AppUtils';
import { hideBackButton } from '../../../../actions/historyActions';
import { fetchAxaGoalDashboardPolicy } from '../../actions/dashboardAction';
import DashboardCard from '../../components/DashboardCard';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { getLanguage } from '../../../../selectors/userSelectors';
import {
  getDashboardLoading,
  getDashboardPoliciesData,
} from '../../selectors/dashboardSelector';

import LoadingView from '../../../../components/LoadingView';
import BackNavButtonContainer from '../../../emma-customer-profile/containers/BackNavButtonContainer';
import VhisModalView from '../../components/VhisModalView';
import EmmaModalView from '../../../../components/EmmaModalView/EmmaModalView';
import HealthKeeperModalView from '../../../../components/EmmaModalView/HealthKeeperModal/HealthKeeperModalView';

import './style.scss';

import { INSURED_ROLE_NAME } from '../../constants/constants';

interface DashboardProps {
  isLoading: boolean;
  lang: string;
  policyGroups: any;
  onFetchAxaGoalDashboardPolicy: (payload: any) => void;
}

class Dashboard extends Component<DashboardProps & RouteComponentProps> {
  componentDidMount() {
    if (isApp()) {
      const title = t(`AXA_GOAL_SEE_ALL_POLICY_TITLE`);
      title && setNavigationBarTitle(title);
    }
    this.props.onFetchAxaGoalDashboardPolicy({});
  }

  componentWillUnmount() {
    if (isApp()) {
      setNavigationBarTitle(' ');
    }
  }

  render() {
    const { isLoading, policyGroups } = this.props;
    return isLoading ? (
      <LoadingView />
    ) : (
      <div className="emma-stylesheet-grid-system axa-goal-see-all">
        <EmmaModalView />
        <VhisModalView />
        <HealthKeeperModalView />
        <div>
          {(() => {
            if (!policyGroups || !policyGroups.length) {
              console.error('policyGroups Undefined');
              return '';
            }
            if (!policyGroups.find((group: any) => group.policies.length)) {
              console.error(
                'No AXA Goal Policy Found, user should never reach this page? unexpected',
              );
              return '';
            }
            return policyGroups.map((group: any) => {
              if (!group.policies || !group.policies.length) {
                return '';
              }
              return (
                <div>
                  <div>
                    <h1>
                      {group.title} ({group.policies.length})
                    </h1>
                  </div>
                  <div className="axa-goal-dashboard-card-container">
                    {group.policies.length &&
                      group.policies.map((policy: any) => (
                        <DashboardCard {...policy} />
                      ))}
                  </div>
                </div>
              );
            });
          })()}
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const lang = getLanguage(state);
    const { dashboardPolicies } = getDashboardPoliciesData(state);
    const isLoading = getDashboardLoading(state);
    // const { policyTitle, policyLength, isShowViewAllCard, isShowTrackingDevice } = dashboardPoliciesData;
    const policyGroups = groupDashboardPoliciesData(dashboardPolicies);
    return {
      isLoading,
      lang,
      policyGroups,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onFetchAxaGoalDashboardPolicy: (payload: any) =>
        dispatch(fetchAxaGoalDashboardPolicy(payload)),
      onHideBackButton: () => dispatch(hideBackButton()),
    };
  }
}

interface PolicyProps {
  isAxaGoal: boolean; // to be removed
  title: string;
  policyDetails: any;
}
interface PolicyGroupProps {
  // type: string,
  title: string;
  policies: Array<PolicyProps>;
}
interface PolicyGroupsProps {
  [type: string]: PolicyGroupProps;
}

function groupDashboardPoliciesData(dashboardPolicies: Array<PolicyProps>) {
  // 1. Action required
  //   S1. Grant Access
  //   S2. Send a reminder to the insured person
  //   S3. Reminder of AXA Goal enrollment
  // 2. My policy(ies)
  //   user == insured
  // 3. My family's policy(ies)
  //   user != insured

  // reset
  const POLICY_GROUPS: PolicyGroupsProps = {
    actionRequired: {
      title: t('AXA_GOAL_SEE_ALL_POLICY_TITLE_MY_ACTION_REQUIRED'),
      policies: [],
    },
    myPolicy: {
      title: t('AXA_GOAL_SEE_ALL_POLICY_TITLE_MY_POLICY'),
      policies: [],
    },
    myFamily: {
      title: t('AXA_GOAL_SEE_ALL_POLICY_TITLE_MY_FAMILY'),
      policies: [],
    },
  };

  for (const policy of dashboardPolicies) {
    try {
      const { policyDetails } = policy;
      // skip if it is not an AXA Goal
      if (!isAxaGoalPolicy(policyDetails)) {
        console.error(
          'non AXA Goal policies should be been filtered from the upper stream, should not reach this line',
        );
        continue;
      }
      // group to Action Required
      if (isActionRequiredPolicy(policyDetails)) {
        POLICY_GROUPS.actionRequired.policies.push(policy);
        continue;
      }
      const isMyPolicy = policyDetails.partyRoleCd.includes(INSURED_ROLE_NAME);
      // INS or INS=OWN grouped to My Policy
      if (isMyPolicy) {
        POLICY_GROUPS.myPolicy.policies.push(policy);
        continue;
      }
      // OWN grouped to My Family's Policy
      POLICY_GROUPS.myFamily.policies.push(policy);
      continue;
    } catch (err) {
      console.error(err);
    }
  }

  return Object.values(POLICY_GROUPS);
}

function isAxaGoalPolicy(policyDetails: any) {
  return policyDetails.isWiseGuardProPolicyFlag === 'Y';
}
function isActionRequiredPolicy(policyDetails: any) {
  if (
    policyDetails.insuredAccessFlag !== 'Y' &&
    policyDetails.isOwnerInsuredFlag !== 'Y'
  ) {
    return true;
  }
  if (policyDetails.isInsuredAxaGoalEnrolled !== 'Y') {
    return true;
  }
  return false;
}

export default connect(
  Dashboard.mapStateToProps,
  Dashboard.mapDispatchToProps,
)(Dashboard);
